const EyeIcon = () => (
  <svg
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0.625C10.1875 0.625 11.9648 1.63672 13.25 2.83984C14.5352 4.01562 15.3828 5.4375 15.793 6.42188C15.875 6.64062 15.875 6.88672 15.793 7.10547C15.3828 8.0625 14.5352 9.48438 13.25 10.6875C11.9648 11.8906 10.1875 12.875 8 12.875C5.78516 12.875 4.00781 11.8906 2.72266 10.6875C1.4375 9.48438 0.589844 8.0625 0.179688 7.10547C0.0976562 6.88672 0.0976562 6.64062 0.179688 6.42188C0.589844 5.4375 1.4375 4.01562 2.72266 2.83984C4.00781 1.63672 5.78516 0.625 8 0.625ZM11.9375 6.75C11.9375 4.58984 10.1602 2.8125 8 2.8125C5.8125 2.8125 4.0625 4.58984 4.0625 6.75C4.0625 8.9375 5.8125 10.6875 8 10.6875C10.1602 10.6875 11.9375 8.9375 11.9375 6.75ZM8 5C8 4.69922 7.89062 4.39844 7.75391 4.15234C7.83594 4.15234 7.91797 4.125 8 4.125C9.44922 4.125 10.625 5.30078 10.625 6.75C10.625 8.19922 9.44922 9.375 8 9.375C6.55078 9.375 5.375 8.19922 5.375 6.75C5.375 6.69531 5.375 6.61328 5.375 6.53125C5.62109 6.66797 5.92188 6.75 6.25 6.75C7.20703 6.75 8 5.98438 8 5Z"
      fill="#7464B2"
    ></path>
  </svg>
);

export default EyeIcon;
